import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Title = styled.h1`
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 10px 0;
    text-align: center;
    width: 100%;
`;

export const ContainerRow = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
    @media (min-width: 1100px) {
        align-items: flex-start;
        flex-direction: row;
        justify-content: flex-start;
    }

    .personal-data {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        width: auto;
        
        @media (min-width: 1100px) {
            flex-direction: row;
            width: 70%;
        }

        .input-column{
            width: 100%;
            @media (min-width: 1100px) {
                width: 45%;
            }
        }
    }
`;

export const ContainerColumn = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: flex-start;
    padding: 20px;
    width: 80%;
    @media (min-width: 1100px) {
        width: 30%;
    }

    div#confirm-email {
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 100%;
    }
`;

export const ImageIcon = styled(SVG)`
    height: 24px;
    width: 24px;
    & path {
        fill: ${({ $isSpecial }) => !$isSpecial ? 'currentColor' : 'none'};
        stroke: ${({ $isSpecial }) => $isSpecial ? 'currentColor' : 'none'};
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 25px;
    justify-content: center;
    padding-bottom: 150px;
    width: 100%;
    @media (min-width: 1100px) {
        align-self: flex-end;
        justify-content: flex-end;
        margin-right: 10%;
        padding: 20px;
        width: 100%;
    }
`;